import { Alert, Link } from '@amzn/awsui-components-react';
import { useContext } from 'react';

import { constants } from '../../common/Localization';
import { CookieConsentContext } from '../../contexts/CookieConsentContext';


function FeatureNotAvailable(): JSX.Element {

    const { customizeCookies } = useContext(CookieConsentContext);
    
    return (
        <Alert
            data-testid='featureNotAvailable'
            header={constants.FEATURE_NOT_AVAILABLE}
        >
            {constants.VISIT} <Link onFollow={customizeCookies}>{constants.COOKIE_PREFERENCES}</Link> {constants.ALLOW_FUNCTIONAL_COOKIES_TO_ENABLE}
        </Alert>
    );
}

export default FeatureNotAvailable;
